import React from 'react';
import PropTypes from 'prop-types';
import useNavHeight from 'hooks/useNavHeight';
import { useSearchContext } from '../../hooks/useSearch';
import {
  Sticky,
  HeaderBg,
  InputContainer,
  TextInput,
  IconContainer,
  CancelIcon,
  SearchIcon
} from './styled';

const SearchInputHeader = ({ className }) => {
  const { search, setSearch } = useSearchContext();
  const navHeight = useNavHeight();

  return (
    <Sticky bound={navHeight} className={className}>
      <HeaderBg className={className}>
        <InputContainer>
          <TextInput
            type="text"
            placeholder="Search description of cover..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <IconContainer>
            {search?.length > 0 ? (
              <CancelIcon onClick={() => setSearch('')} />
            ) : (
              <SearchIcon />
            )}
          </IconContainer>
        </InputContainer>
      </HeaderBg>
    </Sticky>
  );
};

SearchInputHeader.propTypes = {
  className: PropTypes.string
};

export default SearchInputHeader;
